import { Component, inject } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { selectStatusState } from 'src/app/state'
import { AsyncPipe } from '@angular/common'
import { NgbProgressbar } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'loading-status',
    templateUrl: './loading-status.component.html',
    styleUrls: ['./loading-status.component.scss'],
    imports: [NgbProgressbar, AsyncPipe]
})
export class LoadingStatusComponent {

  public status$: Observable<any>

  public store = inject(Store)
  constructor() {
      this.status$ = this.store.select(selectStatusState)
    }
}
